import * as React from 'react';
import { Query } from '@apollo/client/react/components';

const TrendingResearchItemsQuery = require('buyside/graphql/queries/TrendingResearchItems');

import ErrorBoundary from 'buyside/components/presentation/ErrorBoundary/errorBoundary';
import TrendingResearch from 'buyside/components/presentation/TrendingResearch/trendingResearch';

import { TrendingResearchItemsQuery as TrendingResearchItemsQueryType } from 'interfaces/graphql-typings';

const TrendingResearchContainer: React.FunctionComponent<{ showUserDetails: boolean }> = ({
  showUserDetails
}): React.ReactElement => (
  <ErrorBoundary pageName="trending research">
    <Query<TrendingResearchItemsQueryType> query={TrendingResearchItemsQuery}>
      {({ loading, data }): React.ReactElement => (
        <TrendingResearch
          loading={loading}
          trendingIdeas={data ? data.trendingIdeas : null}
          activeConversationIdeas={data ? data.activeConversationIdeas : null}
          biggestMoverIdeas={data ? data.biggestMoverIdeas : null}
          showUserDetails={showUserDetails}
        />
      )}
    </Query>
  </ErrorBoundary>
);

export default TrendingResearchContainer;
